export default {
    selectedImageEvent(context, image) {
        context.commit('selectedImageEvent', image);
    },

    openWindowEvent(context) {
        context.commit('openWindowEvent');
    },

    closeWindowEvent(context) {
        context.commit('closeWindowEvent');
    }
}